import {Event as Event_V3} from '@wix/ambassador-events-v3-event/types'
import {getEventId, getFormattedLocation} from '@wix/wix-events-commons-statics'
import classNames from 'classnames'
import React from 'react'
import {useEventDateInformation} from '../../../../../commons/hooks/dates'
import {useVisibilityStyles} from '../../hooks/use-visibility-styles'
import sc from '../classes.scss'
import s from './short-date-location.scss'

interface ShortDateLocationProps {
  event: wix.events.Event | Event_V3
  dateClassName: string
  locationClassName: string
}

export const ShortDateLocation = ({event, dateClassName, locationClassName}: ShortDateLocationProps) => {
  const {shortStartDate} = useEventDateInformation(getEventId(event))
  const {
    allBreakpoints: {isListDateVisible, isListLocationVisible},
  } = useVisibilityStyles()

  return (
    <div className={classNames(s.container, sc.textLineHeight, s.alignment)} data-hook="ev-short-date-location">
      {isListDateVisible() ? (
        <div className={classNames(s.date, dateClassName)} data-hook="short-date">
          {shortStartDate}
        </div>
      ) : null}
      <div className={classNames(s.divider, dateClassName)} />
      {isListLocationVisible() ? (
        <div className={classNames(s.location, locationClassName)} data-hook="short-location">
          {getFormattedLocation(event)}
        </div>
      ) : null}
    </div>
  )
}
